import { MultiSelectDropdown } from '@repo/ui/OffersFilter/MultiSelectDropdown';
import { useFilterEvents } from '@repo/ui/OffersFilter/useFilterEvents';
import { shallow } from 'zustand/shallow';
import { useOffersFilterStore } from '../store';
import { useRangeFilterOptions } from '../store/hooks';

export const TermLengthSelect = ({
  isStickyBar = false,
  scrollBackToMainBar,
  actionSection,
  pageIdentifier,
  isBankBonusesFilterExperiment,
}: {
  isStickyBar?: boolean;
  scrollBackToMainBar?: () => void;
  actionSection: string;
  pageIdentifier: string;
  isBankBonusesFilterExperiment?: boolean;
}) => {
  const termLengthOptions = useRangeFilterOptions('cdDepositTerm');
  const { handleUpdateFilterFormState, handleApplyFilters, appliedFilters } = useOffersFilterStore(
    ({ handleUpdateFilterFormState, handleApplyFilters, appliedFilters }) => ({
      handleUpdateFilterFormState,
      handleApplyFilters,
      appliedFilters,
    }),
    shallow,
  );
  const { updateFiltersEvent } = useFilterEvents({
    actionSection,
    pageIdentifier,
    additionalAttributes: {},
  });

  const handleTermLengthChange = (selectedLabels: string[]) => {
    if (scrollBackToMainBar) {
      scrollBackToMainBar();
    }

    setTimeout(
      () => {
        handleUpdateFilterFormState({
          selectedTermRanges: selectedLabels,
        });

        const newState = handleApplyFilters();
        if (!newState) return;

        updateFiltersEvent({
          additional_attributes: {
            term_length: selectedLabels,
            min_deposit: newState.appliedFilters.selectedMinDepositRanges,
          },
        });
      },
      scrollBackToMainBar ? 100 : 0,
    );
  };

  return (
    <MultiSelectDropdown
      isStickyBar={isStickyBar}
      label="Term Length"
      options={termLengthOptions}
      selectedOptions={appliedFilters?.selectedTermRanges || []}
      onChange={handleTermLengthChange}
      useStore={useOffersFilterStore}
      isBankBonusesFilterExperiment={isBankBonusesFilterExperiment}
    />
  );
};
